// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2InK7","body":"styles_body__1LWfG","buttons":"styles_buttons__G4nI-","manualInputPage":"styles_manualInputPage__1pJwV"};